import { AppConfigService } from '../../app-load/services/app-config.service';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { OAuthApi } from '@app/modules/core/api/oauth.api';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { RefreshTokenApi } from '../api/oauth.api';
import {CustomHttpParamEncoder} from "@app/modules/core/functions/custom-http-param.encoder";
@Injectable()
export class AuthService {
  private readonly apiRoutes = {
    login: (): string => `${this.endPoint}/token`,
    refresh: (): string => `${this.endPoint}/token`,
    logout: (): string => `${this.endPoint}/revoke`
  };

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {}
  get endPoint(): string {
    return (
      this.appConfigService.getConfig().apiGatewayEndpoint +
      '/api/rest/v2/oauth'
    );
  }

  refreshAccessToken(
    refreshToken: string
  ): Observable<RefreshTokenApi.Response> {
    const httpParams = new HttpParams()
      .append('grant_type', 'refresh_token')
      .append('refresh_token', refreshToken);
    return this.http.post<RefreshTokenApi.Response>(
      this.appConfigService.getConfig().apiGatewayEndpoint +
        '/api/rest/v2/oauth/token',
      encodeURI(httpParams.toString()),
      this.getHttpOptions()
    );
  }

  logout(accessToken: string): Observable<void> {
    const httpParams = new HttpParams().append('token', accessToken);
    return this.http.post<void>(
      this.apiRoutes.logout(),
      encodeURI(httpParams.toString()),
      this.getHttpOptions()
    );
  }

  login(
    userName: string,
    password: string
  ): Observable<OAuthApi.Login.Response> {
    const httpParams = new HttpParams({encoder: new CustomHttpParamEncoder()})
      .append('username', userName)
      .append('password', password)
      .append('grant_type', 'password');
    return this.http.post<OAuthApi.Login.Response>(
      this.apiRoutes.login(),
      httpParams,
      this.getHttpOptions()
    );
  }

  private getHttpOptions() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic ' + this.appConfigService.getConfig().clientSecret
      })
    };
    return httpOptions;
  }
}
